
import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getCurrentLocale (routing = {}) {
  let {locale = ROUTING_STATE_SHAPE.getAt(routing, ['defaultLocale'])} = ROUTING_STATE_SHAPE.getAt(routing, ['current', 'params']) || {};
  return locale;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getCurrentLocale.js